// Main Layout Component
import { useRef, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { AgentStatusBanner } from '../AgentStatusBanner';
import { Outlet, useLocation } from 'react-router-dom';

export function MainLayout() {
  const mainRef = useRef<HTMLElement>(null);
  const location = useLocation();

  // PLAT-002: Mover foco al contenido principal al cambiar de ruta.
  // Usuarios de teclado no deben re-tabular por sidebar y header en cada navegación.
  useEffect(() => {
    mainRef.current?.focus({ preventScroll: true });
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950 overflow-hidden">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* NAV-03: AgentStatusBanner dentro del layout (entre header y contenido)
            para evitar empujar todo el layout hacia abajo */}
        <AgentStatusBanner />
        <Header />
        <main
          ref={mainRef}
          tabIndex={-1}
          className="flex-1 overflow-y-auto overflow-x-hidden outline-none"
        >
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
